module.exports = __webpack_public_path__ + "assets/img/e9739c62ad5ad8de18ed75fda6928b9b.svg";